import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintainAbleCard(params) {
  return maintainRequest({
    url: `/user/maintenanceMan/card/enableCard`,
    method: "post",
    params: params,
  });
}
